export default __webpack_public_path__ + "static/media/guide_create_5.46168545.jpg";